import psl_ui from '../../libs/psl_ui.js';

import template from './template.pst';

import {wait} from '../../libs/psl_polyfills.js';

import './style.scss';

import path from '../../path.js';

psl_ui.templates.add('component_instructions',template);

const {els,rpoints}=psl_ui.templates.render('component_instructions');

const _el=els[0];
const _btn=els[1];

let _status='shown';

const _show = async () => {
	if(_status==='shown') return;
	rpoints.btn.classList.add('hidden');
	_container.appendChild(_el,_container.firstChild);
	await wait(1);
	_el.classList.remove('hidden');
	await wait(375);
	_btn.parentNode?.removeChild(_btn);

	_status = 'shown';
}

window.addEventListener('resize',()=>{
	if(!_el.parentNode && !_btn.parentNode) return;
	_resize();
});

function _resize(){
	let width=window.innerWidth;
	let height=window.innerHeight;
	let coef = 1;

	if(width>height){
		width=width/1920;
		height=height/1080;
	} else {
		width=width/1080;
		height=height/1920;
	}

	coef = Math.min(width,height);

	_btn.style.transform=`scale3d(${coef},${coef},1)`;
}

const _hide = async () => {
	if(_status==='hidden') return;
	_el.classList.add('hidden');

	_el.parentNode.parentNode.appendChild(_btn);
	await wait(1);
	rpoints.btn.classList.remove('hidden');
	await wait(250);
	_el.parentNode?.removeChild(_el);

	rpoints.close.setAttribute('aria-label','Close');
	rpoints.close_text.innerHTML='Close';
	rpoints.close_img.src=`${path()}img/instructions_close.svg`;

	_status = 'hidden';

	await wait(250);
	rpoints.close.classList.remove('animated');
}

let _clb;
let _container;

const _append = async (container,clb) => {
	_el.classList.add('instant');
	rpoints.btn.classList.add('instant');
	_container = container;
	_container.appendChild(_el,_container.firstChild);
	_el.classList.remove('hidden');
	rpoints.btn.classList.add('hidden');
	await wait(1);

	rpoints.close.setAttribute('aria-label','Play');
	rpoints.close.classList.add('animated');
	rpoints.close_text.innerHTML='Play';
	rpoints.close_img.src=`${path()}img/instructions_play.svg`;

	_el.classList.remove('instant');
	rpoints.btn.classList.remove('instant');
	_status = 'shown';

	_clb = clb;

	_resize();

	rpoints.header.focus();
}

const _remove = async () => {
	if(_el.parentNode){
		_el.classList.add('hidden');
		await wait(250);
		_el.parentNode.removeChild(_el);
	}
	if(_btn.parentNode){
		rpoints.btn.classList.add('hidden');
		await wait(250);
		_btn.parentNode.removeChild(_btn);
	}
}

rpoints.btn.addEventListener('click',_show);
rpoints.close.addEventListener('click',()=>{
	if(_clb) _clb();
	_hide();
	_clb = undefined;
});

export default {
	view:_el,
	btn:_btn,
	hide:_hide,
	show:_show,
	append:_append,
	remove:_remove,
	set text(text){
		rpoints.text.innerHTML=text;
	},
}
